import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Banner } from '../../components';
import { Loader } from '../../components';
import { useParams } from "react-router-dom";
import {ArticlesColumn} from '../../components'
import { BaseUrl } from "../../config";

const NewsCategoryContainer = (props) => {
  const loader = useSelector((state) => state.loader);
  let { slug } = useParams();
  const [categoryData, setcategoryData] = useState({})

  useEffect(() => {

    fetch(`${BaseUrl}/page?key=invrsion&slug=${slug}&page=${slug}`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
      
    }).then((json) =>  {
     
      setcategoryData(json.data.index_news.list_news);
    })
    
    
  }, []);


  const arrayLoad = [
    require('../../assets/parallax-1.jpg')
  ]

  return (
    <React.Fragment>
      {
        categoryData.length > 0 &&
        <ArticlesColumn articles={categoryData} isCategory={true} slug={slug} />
      }
      
      {/* <Banner text="Want to dive deeper? Get your hands on our press kit" route="/contact" copyRoute="Discover" isDownload={true}/> */}
      <Loader isFetching={categoryData.length > 0} arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default NewsCategoryContainer;
